export const eventNameEnums = {
  CHAT_UPDATE: 'chatUpdate',
  CHAT_META_UPDATE: 'chatMetaUpdate',
  CHAT_MEMBERS_UPDATE: 'chatMembersUpdate',
  CHAT_META_MEMBERS_UPDATE: 'chatMetaMembersUpdate',
  CHAT_NOTE_UPDATE: 'noteUpdate',
  CHAT_NOTE_DELETE: 'noteDelete',
  CHAT_NOTE_CREATE: 'noteCreate',
  CHAT_OBJECTIVE_FILES_CREATE: 'objectiveFilesCreate',
  CHAT_OBJECTIVE_FILES_UPDATE: 'objectiveFilesUpdate',
  CHAT_OBJECTIVE_FILES_DELETE: 'objectiveFilesDelete',
  CHAT_THREAD_CREATE: 'threadCreate',
  CHAT_THREAD_DELETE: 'threadDelete',
  CHAT_THREAD_UPDATE: 'threadUpdate',
  CHAT_THREAD_META_UPDATE: 'threadMetaUpdate',
  REACTIONS_UPDATE: 'reactionsUpdate'
}
